/* tslint:disable */
/// <reference path="./redux-shortcuts.d.ts" />
/// <reference path="./react-height.d.ts" />
/// <reference path="./react-collapse.d.ts" />
/// <reference path="./element-class.d.ts" />
/// <reference path="./react-async-loading.d.ts" />
/// <reference path="./svgmodule.d.ts" />
/// <reference types="@types/node" />
/* tslint:enable */

export interface IModal {
    id: number;
    type: string;
    title: string;
    tabs: ITab[];
    form: IFormElement[];
    content: string;
    isClickable: boolean;
    hasBackdrop: boolean;
}

export interface ITab {
    id: number;
    type: string;
    title: string;
    content: string;
}

export interface IFormElement {
    id: number;
    label: string;
    type: string;
    name: string;
    placeholder: string;
    value: any;
}

export declare type IEntity = INote | IBookmark | INoteShared | IQuestion;

export declare type IEntityNote = INote | INoteShared | IQuestion;

export interface INote {
    id: number;
    // documentId used during create
    documentId?: string;
    categoryId: number;
    pageId: number;
    pageNumber: number;
    url: string;
    breadcrumb: string;    
    text: string;
    created: any; // Datetime / timestamp
    lastEdited: any; // Datetime / timestamp
    startElementXPath: string;
    startCharacter: number;
    endElementXPath: string;
    endCharacter: number;
    pageState: string;
    userId: string;
    noteParticipantsIDs: string[] | undefined;    
    noteParticipantGroupIDs: string[] | undefined;  
    isquestion: boolean;  
}

// Question related
export interface IQuestionPart {
    antwoordConcern?: string;  
    status?: number;
    practicionerId?: string;
    parentId?: number;  // noteId
}

export interface IQuestionDB extends IQuestionPart {
    id: number;
    noteId: number;
    documentId: string;
}

export interface IQuestion extends INote, IQuestionPart {
}
// Question related

export interface INoteShared extends INote { 
    isShared: boolean;
}

export interface IParticipant { 
    key: number;
    id: string;
    tenantName: string;
    name: string;
    email: string;
    isUser: boolean;
}

export interface IParticipantId { 
    id: string;
}

export interface INoteParticipant extends IParticipant { 
    noteid?: number;
}

export interface IUsergroupParticipant extends IUsergroup { 
    usergroupid?: number;
}

export interface IBookmark {
    id: number;
    // documentId used during create
    documentId?: string;
    categoryId: number;
    pageId: number;
    pageNumber: number;
    url: string;
    name: string;
    created: any; // Datetime / timestamp
    lastEdited: any; // Datetime / timestamp
    status: string;
}

export interface ICategory {
    id: number;
    // documentId used during create
    documentId?: string;
    name: string;
    color: string;
}

export interface INoteChat {
    id: number;
    noteId: number;
    created: any; // Datetime / timestamp
    userId: string;    
    text: string;
    attached: boolean;
}

export interface IEmailMessage {
    id: number;
    documentId: string;
    mailToName: string;
    mailToAddresses: string;
    dateEmail: any;
    dateEmailString: string;
    mailFromId: string;
    mailFromName: string;
    mailFromAddress: string;
    relatiebreadcrumb: string;
    relatiepageUrl: string;
    pageUrl: string;
    pageBreadcrumb: string;
    pageId: number; 
    subject: string;
    emailtext: string;
    htmlMail: string;
    isQuestion: boolean;
    emailParticipantsIDs: string[] | undefined;
    emailParticipantGroupIDs: string[] | undefined;    
    defaultParticipantSet: boolean;
    noteIDs: string[] | undefined;
    publicatie: string;
}

export class INoteAndParticipant {
    id: number;
    created: any;
    pageNumber: number;
    item: IEmailMessage|INote|INoteShared|any;    
    user?: IParticipant;
}

export class NoteAndParticipant {
    id: number;
    created: any;
    pageNumber: number;
    item: INote|INoteShared|any;    
    user?: IParticipant;
    constructor(obj: any, user?: IParticipant) {
        this.id = obj.id;
        this.created= obj.created;
        this.item = obj;
        this.user = user;
    }
}

export interface IUsergroup {
    key: string;
    id: number;
    type?: number;
    name: string;
    userId: string;
    userIDs: string[] | undefined;
    allTenantUsers: boolean;
}

export interface IEmailParticipant extends IParticipant { 
    emailid?: number;
}

export interface IQuestionAddressee {
    id: number;
    name: string;
    email: string;
}

export interface IAdmin {
    id?: number;
    documentId?: string;
    modquestion: boolean;
    deadlinequestion?: any; // Datetime / timestamp
    deadlineanswer?: any; // Datetime / timestamp
    factionvisible: boolean;
}

export function isNote(data: any): data is INote {
  return data && (data.startElementXPath || data.StartElementXPath);
}

export function isQuestion(data: any): data is IQuestion {
    return data && (!!data.isquestion || !!data.status);
  }

export function isSharedNote(data: any): data is INoteShared {
    return data && data.isShared && (data.startElementXPath || data.StartElementXPath);
}

export function isCategory(data: any): data is ICategory {
    return data && data.color;
}

export function isEmail(data: any): data is IEmailMessage {
    return data && (data.emailtext);
}

export function isParticipant(data: any): data is IParticipant {
    return data && (data.name) && (data.email);
}

export function isUsergroup(data: any): data is IUsergroup {
    return data && (data.name) && (data.userIDs);
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/types/index.tsx